import { Type } from "@sinclair/typebox";
const annualFee = Type.String({
    pattern: "^(?:0|[1-9][0-9]{0,6})(?:\\.[0-9]{1,2})?$",
    maxLength: 10
});
export const quoteContractOptionsSchema = Type.Union([
    Type.Object({ preset: Type.Literal("standard") }, { additionalProperties: false }),
    Type.Object({ preset: Type.Literal("maintenance"), annualFee }, { additionalProperties: false }),
    Type.Object({ preset: Type.Literal("maintenance_lifeline"), annualFee, lifelineAnnualFee: annualFee }, { additionalProperties: false })
]);
/** Also used by internal callers: schema validation at HTTP alone is insufficient. */
export function contractOptionsError(value) {
    if (value.preset === "standard")
        return;
    const valid = (fee) => /^(?:0|[1-9][0-9]{0,6})(?:\.[0-9]{1,2})?$/.test(fee) && Number(fee) > 0;
    if (!valid(value.annualFee))
        return "Inserisci un importo annuale maggiore di zero per la manutenzione dell’opera.";
    if (value.preset === "maintenance_lifeline" && !valid(value.lifelineAnnualFee))
        return "Inserisci un importo annuale maggiore di zero per la manutenzione della linea vita.";
}
/** Keep all known properties at the outer level: Fastify/Ajv removes additional
 * properties while exploring unions, which would otherwise erase valid fees. */
export const quoteContractOptionsInputSchema = Type.Unsafe({
    ...Type.Object({
        preset: Type.Union([
            Type.Literal("standard"),
            Type.Literal("maintenance"),
            Type.Literal("maintenance_lifeline")
        ]),
        annualFee: Type.Optional(annualFee),
        lifelineAnnualFee: Type.Optional(annualFee)
    }, { additionalProperties: false }),
    anyOf: [
        {
            properties: { preset: { const: "standard" } },
            not: { anyOf: [{ required: ["annualFee"] }, { required: ["lifelineAnnualFee"] }] }
        },
        {
            properties: { preset: { const: "maintenance" } },
            required: ["annualFee"],
            not: { required: ["lifelineAnnualFee"] }
        },
        {
            properties: { preset: { const: "maintenance_lifeline" } },
            required: ["annualFee", "lifelineAnnualFee"]
        }
    ]
});
//# sourceMappingURL=quote-contract-options.js.map